const jwtSecret = "819cf83ab8e3e9fa19b5ba631c2156b8";

export default jwtSecret;